import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect, useMemo } from 'react';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { ButtonBarState } from '../../store/birdElement/buttonBarState';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { SegmentedButton, } from '@sas/nova-commons/components/SegmentedButton';
import { selectBirdButtonBarState, selectStyleState, selectAccessibilityLabelState, } from '../../store/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { tokensToStyle, tokensToSelectedStyle } from '../utils/tokensToStyle';
import { fontStyles, textHeight, longestTextWidth, totalTextWidth } from '../utils/style';
import { useFontLoadedKey } from '../FontProvider';
const buttonWidthPadding = 32 /* left and right padding */ + 1; /* all buttons have at least 1px border */
export const BirdButtonBarBase = ({ id, preferredSizing, state, actions, style, accessibilityLabel, }) => {
    const { values, measureValues, selectedIndex, orientation, required } = state;
    const combinedValues = useMemo(() => {
        return values && measureValues && measureValues.length
            ? values.map((value, index) => {
                if (measureValues.length <= index) {
                    return value;
                }
                const measureValue = measureValues[index];
                if (measureValue.length < 1) {
                    return value;
                }
                return value + ' (' + measureValue + ')';
            })
            : values || [];
    }, [values, measureValues]);
    {
        const { font } = style || {};
        const dt = useDesignTokens();
        const fonts = useMemo(() => fontStyles(font, dt), [font, dt]);
        const fontKey = useFontLoadedKey(fonts.fontFamily);
        useLayoutEffect(() => {
            const buttonHeight = Math.max(28 /* min height 1.75rem */, textHeight(fonts) + 8 /* padding */ + 2 /* border */);
            if (orientation === 'vertical') {
                const valLength = combinedValues ? combinedValues.length : 0;
                actions.setConstraints(id, {
                    preferredHeight: buttonHeight * valLength,
                    minHeight: buttonHeight * Math.min(3, valLength),
                    minWidth: Math.max(longestTextWidth(combinedValues, fonts) + buttonWidthPadding + 1, 100),
                });
            }
            else {
                const scrollWidth = totalTextWidth(combinedValues, fonts) + buttonWidthPadding * combinedValues.length + 1;
                let constraints = {
                    preferredHeight: buttonHeight,
                    minHeight: buttonHeight,
                    minWidth: Math.max(100, Math.min(scrollWidth, 160)),
                };
                if (preferredSizing) {
                    constraints = Object.assign(Object.assign({}, constraints), { preferredWidth: scrollWidth });
                }
                actions.setConstraints(id, constraints);
            }
        }, [fontKey /*(implicit)*/, orientation, combinedValues, actions, id, preferredSizing, fonts]);
    }
    const styleOverride = ({ selected }) => {
        return selected ? tokensToSelectedStyle(style) : tokensToStyle(style);
    };
    function onSelectedIndex(index) {
        actions.update(id, {
            selectedIndex: index !== null && index !== void 0 ? index : undefined,
        });
    }
    const surfaceStyle = orientation === 'vertical'
        ? {
            height: '100%',
            flexShrink: 1,
            minHeight: 0,
            overflowX: 'hidden',
            overflowY: 'auto',
            display: 'flex',
        }
        : {
            display: 'flex',
            flexGrow: preferredSizing ? 0 : 1,
            flexDirection: 'column',
            minHeight: 0,
        };
    return (_jsx("div", Object.assign({ style: surfaceStyle }, { children: _jsx(SegmentedButton, { orientation: orientation, values: combinedValues, selectedIndex: selectedIndex, onSelectedIndex: onSelectedIndex, buttonStyle: styleOverride, style: { flexGrow: 1 }, deselectable: !required, ariaLabel: accessibilityLabel, scrollable: true, variableWidth: true }) })));
};
export const BirdButtonBar = connect((state, props) => ({
    state: selectBirdButtonBarState(state, props.id),
    style: selectStyleState(state, props.id),
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, ButtonBarState.actions), dispatch),
}))(BirdButtonBarBase);
